// @core
import { i18n } from 'core/i18n';

// @utilities
import DateHelper from 'utilities/dateHelper';
import { getLastNChars } from 'utilities/stringHelper'

// @constants
import { DATE_PICKER_CUSTOM_DATE_FORMAT } from 'constants/commonsComponents'
import { WIZARD_FIRST_STEP, WIZARD_SECOND_STEP, WIZARD_THIRD_STEP, WIZARD_FOURTH_STEP } from "constants";
import { AUTHORISE_REQUEST, AUTHORISE_STEPS, CARD_DETAILS_TEMPLATE, STATUSES, VISIBLE_STEPS } from '../constants/bringAccountConstants';


const { formatText } = i18n;

export const getBreadcrumb = (immAccount) => {
    return [
        {
            text: formatText('accounts-accounts'),
            url: '/myprofile/accounts'
        },
        {
            text: immAccount.get('alias'),
            url: `/myprofile/accounts/${immAccount.get('accountId')}/movements`
        },
        {
            text: formatText("transfer_account-transfer_account_from_another_bank_thread_title"),
            url: ''
        }
    ]
};

const getHasCheckboxChecked = (immBringAccount, checkboxGroup) => {
    return immBringAccount.get(checkboxGroup).some(checkbox => !!checkbox);
}

export const validateByStep = (previousState, { currentStep }) => {
    switch (currentStep) {
        case WIZARD_FIRST_STEP: {
            const ibanExists = previousState.getIn(['iban', 'exists'])
            const entityStatus = previousState.getIn(['entity', 'status']);
            const executionDateIsVald = previousState.get('executionDateIsVald');
            return ibanExists && (entityStatus != STATUSES.IDLE && entityStatus != STATUSES.FETCHING) && executionDateIsVald;
        }
        case WIZARD_SECOND_STEP: {
            return true;
        }
        case WIZARD_THIRD_STEP: {
            const hasAuthoriseRequestChecked = getHasCheckboxChecked(previousState, AUTHORISE_REQUEST);
            const hasAuthoriseStepsChecked = getHasCheckboxChecked(previousState, AUTHORISE_STEPS);
            return hasAuthoriseRequestChecked && hasAuthoriseStepsChecked;
        }
        case WIZARD_FOURTH_STEP: {
            return true;
        }
    }
    return false;
}


export const formatDate = (date) => {
    return DateHelper.formatDate(date, formatText(DATE_PICKER_CUSTOM_DATE_FORMAT))
}

export const getCardDetails = (immAccount, immBringAccount) => {
    const undefinedValue = formatText('transfer_account-transfer_account_from_another_bank_step1_summary_placeholder');

    return CARD_DETAILS_TEMPLATE.map(detail => {
        if (detail.id === 'originAccount') {
            const ibanNumber = immBringAccount.getIn(['iban', 'number']);
            const existsIban = immBringAccount.getIn(['iban', 'exists']);

            return {
                ...detail,
                value: existsIban ? ibanNumber: undefinedValue
            };
        }
        if (detail.id === 'entity') {
            const entityName = immBringAccount.getIn(['entity', 'bank_name']);
            const status = immBringAccount.getIn(['entity', 'status']);

            return {
                ...detail,
                value: entityName ?? undefinedValue,
                visible: (status === STATUSES.ERROR ? {} : VISIBLE_STEPS)
            };
        }
        if (detail.id === 'openbankAccount') {
            const lastFourDigits = getLastNChars(immAccount.get('iban'), 4);
            return {
                ...detail,
                value: `${immAccount.get('alias')} ${lastFourDigits}`,
            };
        }
        if (detail.id === 'applicationDate') {
            const executionDate = immBringAccount.get('executionDate');
            const formattedDate = formatDate(executionDate);

            return {
                ...detail,
                value: formattedDate,
            };
        }
        return detail;
    });
};

export const getConfirmationResume = (immAccount, immBringAccount) => {
    const lastFourDigits = getLastNChars(immAccount.get('iban'), 4);
    const accountAlias = immAccount.get('alias');
    const executionDate = immBringAccount.get('executionDate');
    const formattedDate = formatDate(executionDate);

    return {
        destinationAccount: `${accountAlias} ${lastFourDigits}`,
        originAccount: immBringAccount.getIn(['iban', 'number']),
        originEntity: immBringAccount.getIn(['entity', 'bank_name']),
        executionDate: formattedDate,
    }
}

export const getIbanMessageError = (ibanErrors) => {
    if (!ibanErrors) {
        return ""
    }
    const { isValidIban, existsIban } = ibanErrors;

    if (!isValidIban) {
        return formatText('transfer_account-transfer_account_from_another_bank_step1_iban_number_error_1');
    }

    if (!existsIban) {
        return formatText('transfer_account-transfer_account_from_another_bank_step1_iban_number_error_2');
    }

    return null;
}

export const getAssitantTitle = (isOffice) => {
    return isOffice
        ? formatText('transfer_account_oficina-transfer_account_from_another_bank_step1_disclaimer_title_of')
        : formatText('transfer_account_cc-transfer_account_from_another_bank_step1_disclaimer_title_cc')
}
